export function formatCpfOrCnpj(value: string): string {
  if (value) {
    const cleaned = value.replace(/\D/g, '');

    if (cleaned.length === 11) {
      return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (cleaned.length === 14) {
      return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    } else {
      return value;
    }
  }
  return '';
}

export function formatPaymentDate(value: string) : string {
  const date = new Date(value);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  const hour = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  return `${day}/${month}/${year} ${hour}:${minutes}:${seconds}`;
}

export function formatParcels(value: number) : string {
  let parcel = value.toString();

  if (value == 1)
  {
    return "à vista"
  }

  return parcel;
}

export function formatStatus(status: number): string {
  let statusString: string = '';

  if (status === 0) {
    statusString = 'Pendente';
  } else if (status === 1) {
    statusString = 'Confirmada';
  } else if (status === 2) {
    statusString = 'Desfeita';
  } else if (status === 3) {
    statusString = 'Negada';
  } else if (status === 4) {
    statusString = 'Cancelada';
  }

  return statusString;
}

export function formatDocumentType(value: string): string {
  let formattedValue = 'Documento';

  if (value) formattedValue = formatCpfOrCnpj(value);

  if (formattedValue.length == 18) {
    return "CNPJ"
  } else if (formattedValue.length == 14) {
    return "CPF"
  }

  return formattedValue;
}
